import { EMPTY_STRING } from '../../../../constants/common'

const MESSAGE_TEMPLATE_SELECT_PAGE_SIZE = 10

export const REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE = 'template'

export const REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT = 'comment'

export const REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE = {
  [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]: EMPTY_STRING,
  [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE]: EMPTY_STRING,
}

export const REQUEST_EDIT_USER_COMMENT_FIELDS_TEMPLATES_PARAMS = {
  hidden: false,
  ordering: 'name',
  page_size: MESSAGE_TEMPLATE_SELECT_PAGE_SIZE,
  tag: 'manager_email',
}
